import { useEffect, useRef } from "react";
import { usePageHeaderContext, PageTab } from "@/contexts/PageHeaderContext";

interface UsePageHeaderOptions {
  title: string | undefined;
  tabs?: PageTab[];
  currentTab?: string;
  onTabChange?: (value: string) => void;
}

export function usePageHeader({
  title,
  tabs,
  currentTab,
  onTabChange,
}: UsePageHeaderOptions) {
  const { setPageHeader, clearPageHeader } = usePageHeaderContext();
  const tabsRef = useRef(tabs);
  const onTabChangeRef = useRef(onTabChange);
  tabsRef.current = tabs;
  onTabChangeRef.current = onTabChange;

  useEffect(() => {
    if (!title) return;
    setPageHeader({
      title,
      tabs: tabsRef.current ?? [],
      currentTab: currentTab ?? null,
      onTabChange: onTabChangeRef.current ?? null,
    });
    document.title = `${title} – Production Hub`;
    return () => {
      clearPageHeader();
      document.title = "Production Hub";
    };
  }, [title, currentTab, setPageHeader, clearPageHeader]);
}
